"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const antd_1 = require("complex-component/antd");
exports.default = (0, vue_1.defineComponent)({
    name: 'MutipleForm',
    components: {
        ComplexEditForm: antd_1.ComplexEditForm
    },
    props: {
        dictionary: {
            type: Object,
            required: true
        },
        data: {
            type: Object,
            required: false
        },
        typeList: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false
        },
        editKey: {
            type: String,
            required: false
        },
    },
    data() {
        return {};
    },
    methods: {
        init() {
            this.$nextTick(() => {
                const formList = this.$refs.form;
                const editKey = this.editKey;
                this.typeList.forEach((val, index) => {
                    const form = formList[index];
                    form.initPageList = function () {
                        this.mainList = this.dictionary.$getList(this.type, undefined, editKey);
                        const pageList = this.dictionary.$buildObserveList(this.type, this.mainList, {
                            mod: this.edit
                        });
                        this.pageList = pageList;
                    };
                    form.show(val, 'change', this.data);
                });
            });
        }
    }
});
